define("checkout/utils/upgrade-downgrade", ["exports", "@ember/debug"], function (_exports, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.isUpgrade = _exports.isDowngrade = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  const isUpgrade = (currentPlan, upcomingPlan, allPlans) => {
    (false && !(currentPlan) && (0, _debug.assert)('Must provide a current plan to isUpgrade', currentPlan));
    (false && !(upcomingPlan) && (0, _debug.assert)('Must provide an upcoming plan to isUpgrade', upcomingPlan));
    (false && !(allPlans) && (0, _debug.assert)('Must provide a list of all plans to isUpgrade', allPlans));
    const currentPlanType = currentPlan.planType;
    const upcomingPlanType = upcomingPlan.planType;
    if (currentPlanType === upcomingPlanType) {
      return false;
    }
    const planTypes = allPlans.map(plan => plan.planType.toLowerCase());
    return planTypes.indexOf(currentPlanType) < planTypes.indexOf(upcomingPlanType);
  };
  _exports.isUpgrade = isUpgrade;
  const isDowngrade = (currentPlan, upcomingPlan, allPlans) => {
    (false && !(currentPlan) && (0, _debug.assert)('Must provide a current plan to isDowngrade', currentPlan));
    (false && !(upcomingPlan) && (0, _debug.assert)('Must provide an upcoming plan to isDowngrade', upcomingPlan));
    (false && !(allPlans) && (0, _debug.assert)('Must provide a list of all plans to isDowngrade', allPlans));
    const currentPlanType = currentPlan.planType;
    const upcomingPlanType = upcomingPlan.planType;
    if (currentPlanType === upcomingPlanType) {
      return false;
    }
    const planTypes = allPlans.map(plan => plan.planType.toLowerCase());
    return planTypes.indexOf(currentPlanType) > planTypes.indexOf(upcomingPlanType);
  };
  _exports.isDowngrade = isDowngrade;
});